var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecentraland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13556_12373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "url(#paint0_linear_13556_12373)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.421 16.8999V36.3999H34.671L18.421 16.8999Z",
    fill: "url(#paint1_linear_13556_12373)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17102 36.3999H18.421V16.8999L2.17102 36.3999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19995 41.6001C6.68195 43.5631 8.43695 45.3181 10.4 46.8001H41.5999C43.563 45.3181 45.318 43.5631 46.7999 41.6001H5.19995Z",
    fill: "#FC9965"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 46.8C14.742 50.063 20.15 52 26 52C31.85 52 37.258 50.063 41.6 46.8H10.4Z",
    fill: "#FF2D55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.879 27.3V41.6H46.8L34.879 27.3Z",
    fill: "url(#paint2_linear_13556_12373)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.879 36.3999H2.17102C2.97702 38.2589 4.00402 40.0009 5.20002 41.5999H34.892V36.3999H34.879Z",
    fill: "#FFBC5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9709 41.6H34.8789V27.3L22.9709 41.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.879 23.3999C38.4689 23.3999 41.379 20.4898 41.379 16.8999C41.379 13.3101 38.4689 10.3999 34.879 10.3999C31.2892 10.3999 28.379 13.3101 28.379 16.8999C28.379 20.4898 31.2892 23.3999 34.879 23.3999Z",
    fill: "#FFC95B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.421 13C20.2159 13 21.671 11.5449 21.671 9.75C21.671 7.95507 20.2159 6.5 18.421 6.5C16.6261 6.5 15.171 7.95507 15.171 9.75C15.171 11.5449 16.6261 13 18.421 13Z",
    fill: "#FFC95B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13556_12373",
    x1: 4438.46,
    y1: 761.54,
    x2: 761.54,
    y2: 4438.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13556_12373",
    x1: 830.369,
    y1: 16.8999,
    x2: 830.369,
    y2: 1966.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13556_12373",
    x1: 630.524,
    y1: 27.3,
    x2: 630.524,
    y2: 1457.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13556_12373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecentraland);
export default __webpack_public_path__ + "static/media/Decentraland.73983304f67d38668f17777b4ce75648.svg";
export { ForwardRef as ReactComponent };